import { useContext } from 'react';
import { I18nContext } from './context';
import { createMessageFormatters } from './message';
export function useI18n(key) {
    const { messages } = useContext(I18nContext);
    if (!messages)
        throw new Error('I18n messages not available in context.');
    const byKey = key ? messages[key] : messages;
    if (!byKey) {
        const keys = Object.keys(messages);
        throw new Error(`No I18n messages by the key "${key}".\nLoaded keys: "${keys}".`);
    }
    if (typeof byKey === 'string')
        throw new Error(`No valid I18n messages by the key "${key}". The key resolves to a string and not an object.`);
    return createMessageFormatters(byKey);
}
//# sourceMappingURL=useI18n.js.map